import api from "../api/CustomerApi";
import { getCustomerToken } from "../utils/CustomerAuth";

const authHeaders = () => {
  const token = getCustomerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ FIXED: Now reads from selectedLocationId
const getActiveLocationId = () => {
  try {
    // Try direct ID storage first (new approach)
    const storedId = localStorage.getItem("selectedLocationId");
    if (storedId) {
      const id = Number(storedId);
      return Number.isFinite(id) && id > 0 ? id : null;
    }
    
    // Fallback: try to find by name (old approach)
    const name = localStorage.getItem("selectedLocation");
    if (!name) return null;
    
    const raw = localStorage.getItem("locationsList");
    if (!raw) return null;
    
    const list = JSON.parse(raw);
    if (!Array.isArray(list)) return null;
    
    const found = list.find(
      (loc) => String(loc?.name || "").toLowerCase() === name.toLowerCase()
    );
    
    return found?.id ? Number(found.id) : null;
  } catch (err) {
    console.error("Error getting location ID:", err);
    return null;
  }
};

export const CartServices = {
  // ✅✅✅ ONLY THIS METHOD CHANGED - adds location_id query param
  getCart: async () => {
    const location_id = getActiveLocationId();
    const res = await api.get("/cart", {
      headers: authHeaders(),
      params: location_id ? { location_id } : {},
    });
    
    return res?.data?.data ?? [];
  },

  // ✅ Everything below stays EXACTLY the same
  add: async ({
    product_id,
    product_info_id = null,
    quantity = 1,
    location_product_price_id = null,
    product_info_location_price_id = null,
  }) => {
    const location_id = getActiveLocationId();

    const payload = {
      product_id,
      quantity,
    };

    if (product_info_id != null) {
      payload.product_info_id = product_info_id;
    }

    if (location_id != null) {
      payload.location_id = location_id;
    }

    if (location_product_price_id != null) {
      payload.location_product_price_id = location_product_price_id;
    }

    if (product_info_location_price_id != null) {
      payload.product_info_location_price_id = product_info_location_price_id;
    }

    const res = await api.post("/cart/add", payload, { headers: authHeaders() });
    return res?.data;
  },

  update: async (cartRowId, quantity) => {
    const location_id = getActiveLocationId();
    const res = await api.put(
      `/cart/update/${cartRowId}`,
      {
        quantity,
        ...(location_id ? { location_id } : {}),
      },
      { headers: authHeaders() }
    );
    return res?.data;
  },

  remove: async (cartRowId) => {
    const res = await api.delete(`/cart/remove/${cartRowId}`, {
      headers: authHeaders(),
    });
    return res?.data;
  },
};